import { Chip, ChipProps } from "@mui/material";
import { WasteInvoiceImportStatus } from "generated-graphql/graphql";

const IMPORT_LABELS = {
  [WasteInvoiceImportStatus.Queued]: "Queued",
  [WasteInvoiceImportStatus.Running]: "Importing",
  [WasteInvoiceImportStatus.Succeeded]: "Imported",
  [WasteInvoiceImportStatus.Failed]: "Import failed",
  [WasteInvoiceImportStatus.Cancelled]: "Cancelled",
  [WasteInvoiceImportStatus.IngestionQueued]: "Ready to import",
  [WasteInvoiceImportStatus.Ingesting]: "Importing",
} satisfies Record<WasteInvoiceImportStatus, string>;

const IMPORT_COLORS = {
  [WasteInvoiceImportStatus.Queued]: "default",
  [WasteInvoiceImportStatus.Running]: "info",
  [WasteInvoiceImportStatus.Succeeded]: "success",
  [WasteInvoiceImportStatus.Failed]: "error",
  [WasteInvoiceImportStatus.Cancelled]: "warning",
  [WasteInvoiceImportStatus.IngestionQueued]: "info",
  [WasteInvoiceImportStatus.Ingesting]: "info",
} satisfies Record<WasteInvoiceImportStatus, ChipProps["color"]>;

export function InvoiceImportStatusChip({ status }: { status: WasteInvoiceImportStatus }) {
  return (
    <Chip
      size="small"
      variant="outlined"
      color={IMPORT_COLORS[status]}
      label={IMPORT_LABELS[status]}
    />
  );
}
